/**
 * Drawer Configuration Utilities
 * 
 * Pure functions for handling drawer configuration merging and defaults.
 */

import type { DrawerConfig } from "../types.js";
import { DEFAULT_DRAWER_CONFIG } from "../types.js";

/**
 * Merge drawer config with defaults
 * 
 * @param id - Drawer ID
 * @param existing - Existing config (if any)
 * @param updates - New config updates
 * @returns Merged drawer config
 */
export function mergeDrawerConfig(
  id: string,
  existing: DrawerConfig | undefined,
  updates: Partial<DrawerConfig>
): DrawerConfig {
  return {
    id,
    ...DEFAULT_DRAWER_CONFIG,
    ...existing,
    ...updates,
  } as DrawerConfig;
}

/**
 * Get default config for a drawer
 * 
 * @param id - Drawer ID
 * @returns Default drawer config
 */
export function getDefaultDrawerConfig(id: string): DrawerConfig {
  return {
    id,
    ...DEFAULT_DRAWER_CONFIG,
  } as DrawerConfig;
}
